var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { BpgExpensesService } from '../bpg-expenses.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingDTOModel, FilterModel } from "../../bpg-common/services/data.services";
import { Location } from '@angular/common';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { UploadService } from 'src/app/bpg-self-services/d-i/upload.service';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
var CreateAndEditExpenseClaimComponent = /** @class */ (function () {
    /**
    * @class CreateAndEditExpenseClaimComponent
    * @constructor
    */
    function CreateAndEditExpenseClaimComponent(formBuilder, bpgEventService, router, spinner, route, location, bpgExpensesService, environment, bpgCommonService, uploadService) {
        this.formBuilder = formBuilder;
        this.bpgEventService = bpgEventService;
        this.router = router;
        this.spinner = spinner;
        this.route = route;
        this.location = location;
        this.bpgExpensesService = bpgExpensesService;
        this.environment = environment;
        this.bpgCommonService = bpgCommonService;
        this.uploadService = uploadService;
        this.uploadDocumentConstant = "Upload document";
        this.fileName = this.uploadDocumentConstant;
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.userAndRoleIdDTO = {
            userId: this.loginData['userId'],
            roleId: localStorage.getItem('adminId')
        };
        this.selectedFiles = [];
        this.expenseClaim = JSON.parse(sessionStorage.getItem('expenseNameAndChapterId'));
        this.eventDateNameList = [];
        this.eventListObj = [];
        this.editExpenseData = JSON.parse(sessionStorage.getItem('editExpenseData'));
        this.supportingDoc1File = null;
        this.supportingDoc2File = null;
        this.supportingDoc3File = null;
        this.supportingDoc4File = null;
        this.supportingDoc1Name = this.uploadDocumentConstant;
        this.supportingDoc2Name = this.uploadDocumentConstant;
        this.landingDTOModel = new LandingDTOModel();
        this.filter = new FilterModel();
        this.adminId = localStorage.getItem('adminId');
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.finalExpenseData = [];
        this.isbpgAdmin = false;
        this.isNaacAdmin = false;
    }
    CreateAndEditExpenseClaimComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
            if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 500);
        if (localStorage.getItem('isbpgAdmin') === 'true') {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem('isNaacAdmin') === 'true') {
            this.isNaacAdmin = true;
        }
        if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== '3' && this.adminId !== '4' && !this.isNaacAdmin && !this.isbpgAdmin) {
            this.router.navigate(['/site-home']);
        }
        this.bpgCommonService.getSessionToken();
        this.HoshinDropDownList = [{ hoshinType: "Community Engagement" }, { hoshinType: "Workforce Readiness" },
            { hoshinType: "Team Member Engagement" }, { hoshinType: "Business Support" }];
        // newly added
        this.route.params.subscribe(function (params) {
            console.log(params.id);
            // bring expense data and set it here
            if (params.id != null && params.id != undefined) {
                _this.bpgExpensesService.getExpenseById(params.id).subscribe(function (data) {
                    if (data != null) {
                        _this.spinner.hide();
                        _this.editExpenseData = data;
                        _this.buildForms();
                    }
                }, function (err) {
                    _this.spinner.hide();
                    if (err.value.statusText === ConstantValues.unknownError) {
                        _this.timeOutError = true;
                    }
                });
            }
        });
        this.bpgEventService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(function (data) {
            _this.chapterDropDownList = data;
            _this.chapterDropDownList.map(function (i) { i.siteName = i.siteName + "-" + i.bpgName; return i; });
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
        this.buildForms();
        if (this.expenseClaim != null) {
            this.disable = true;
            this.getEventListBasedOnChapterSelection(this.expenseClaim.chapterId, this.expenseClaim.eventId);
            this.getHoshinItemsBasedOnChapterSelection(this.expenseClaim.chapterId, this.expenseClaim.eventId, this.expenseClaim.hoshinId);
            this.expenseClaimForm.patchValue({
                chapterId: this.expenseClaim.chapterId,
                eventId: this.expenseClaim.eventId
            });
        }
    };
    /** For getting event list for dropdown
   * @class CreateAndEditExpenseClaimComponent
   * @method getEventListBasedOnChapterSelection
   * @params chapterId
   */
    CreateAndEditExpenseClaimComponent.prototype.getEventListBasedOnChapterSelection = function (chapterId, eventId) {
        var _this = this;
        this.expenseClaimForm.controls['eventId'].setValue(null);
        this.landingData = {
            "filter": {
                "chapterId": chapterId,
                "eventId": eventId
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 100,
            "sortDirection": "ASC",
            "sortProperty": "event_create_date",
            "uid": ""
        };
        this.bpgEventService.getAllEvents(this.landingData).subscribe(function (data) {
            _this.eventList = data.content;
        });
    };
    /** For adding 365 days to current day
     * @class CreateAndEditExpenseClaimComponent
     * @method addDays
     * @params Date, number
     */
    CreateAndEditExpenseClaimComponent.prototype.addDays = function (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    };
    /** For building add event form
       * @class CreateAndEditExpenseClaimComponent
       * @method buildForms
       */
    CreateAndEditExpenseClaimComponent.prototype.buildForms = function () {
        this.expenseClaimForm = this.formBuilder.group({
            expenseId: null,
            chapterId: [null, Validators.required],
            hoshinType: [null, Validators.required],
            isEventExpense: [true, Validators.required],
            eventId: [null, Validators.required],
            hoshinId: [null, Validators.required],
            expenseName: [null, Validators.required],
            totalExpense: [null, Validators.required],
            expenseDesc: [null, Validators.required],
            // detailedEventPurpose: [null, Validators.required],
            supportingDoc1: null,
            supportingDoc2: null,
            supportingDoc3: null,
            supportingDoc4: null,
            expenseClaimedBy: this.loginData['userId'],
            isSubmitted: false,
            expenseStatus: ""
        });
        if (this.editExpenseData != null) {
            if (this.editExpenseData.chapterId != null) {
                this.getEventListBasedOnChapterSelection(this.editExpenseData.chapterId, this.editExpenseData.eventId);
            }
            if (this.editExpenseData.supportingDoc1 != null) {
                this.supportingDoc1Name = this.editExpenseData.supportingDoc1;
            }
            if (this.editExpenseData.supportingDoc2 != null) {
                this.supportingDoc2Name = this.editExpenseData.supportingDoc2;
            }
            if (this.editExpenseData.isEventExpense === true) {
                this.eventId = this.editExpenseData.eventId;
                this.expenseClaimForm.controls['eventId'].enable();
            }
            else if (this.editExpenseData.isEventExpense === false) {
                this.editExpenseData.eventId = null;
                this.expenseClaimForm.controls['eventId'].disable();
            }
            this.hoshinId = this.editExpenseData.hoshinId;
            this.getHoshinItemsBasedOnChapterSelection(this.editExpenseData.chapterId, this.editExpenseData.eventId, this.editExpenseData.hoshinId);
            this.actionTitle = "EDIT";
            this.expenseClaimForm.patchValue(this.editExpenseData);
        }
        else {
            this.actionTitle = "";
        }
    };
    /** To set filename
  * @class CreateAndEditExpenseClaimComponent
  * @method onFileSelected
  */
    CreateAndEditExpenseClaimComponent.prototype.onFileSelected = function (event, index) {
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        if (event.target.files.length > 0) {
            this.fileName = event.target.files[0].name;
            this.fileSize = event.target.files[0].size;
            var allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "xls", "csv"];
            this.fileExtension = this.fileName.split('.').pop();
            if (this.isInArray(allowedExtensions, this.fileExtension)) {
                if (this.fileSize > 5242880) {
                    this.fileSizeExtensionError = true;
                }
                else {
                    this.fileExtensionError = false;
                    this.fileSizeExtensionError = false;
                    if (index === 1) {
                        this.expenseClaimForm.value.supportingDoc1 = this.fileName;
                        this.supportingDoc1Name = this.fileName;
                        this.supportingDoc1File = event.target.files[0];
                    }
                    else if (index === 2) {
                        this.expenseClaimForm.value.supportingDoc2 = this.fileName;
                        this.supportingDoc2Name = this.fileName;
                        this.supportingDoc2File = event.target.files[0];
                    }
                }
            }
            else {
                this.fileExtensionError = true;
            }
        }
    };
    CreateAndEditExpenseClaimComponent.prototype.removeFile = function (index) {
        if (index === 1) {
            this.expenseClaimForm.value.supportingDoc1 = null;
            this.supportingDoc1Name = this.uploadDocumentConstant;
            this.supportingDoc1File = null;
        }
        else if (index === 2) {
            this.expenseClaimForm.value.supportingDoc2 = null;
            this.supportingDoc2Name = this.uploadDocumentConstant;
            this.supportingDoc2File = null;
        }
    };
    /** checks if word exists in array
    * @class CreateAndEditExpenseClaimComponent
    * @method isInArray
    */
    CreateAndEditExpenseClaimComponent.prototype.isInArray = function (array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    };
    /** To save event form
   * @class CreateAndEditExpenseClaimComponent
   * @method saveExpense
   */
    CreateAndEditExpenseClaimComponent.prototype.saveExpense = function (action) {
        var _this = this;
        this.alertSuccess = false;
        this.alertSuccessOnSave = false;
        this.timeOutError = false;
        this.selectedFiles = [];
        if (this.supportingDoc1Name != null && this.supportingDoc1File != null) {
            this.selectedFiles.push(this.supportingDoc1File);
            this.expenseClaimForm.value.supportingDoc1 = this.supportingDoc1Name;
        }
        if (this.supportingDoc2Name != null && this.supportingDoc2File != null) {
            this.selectedFiles.push(this.supportingDoc2File);
            this.expenseClaimForm.value.supportingDoc2 = this.supportingDoc2Name;
        }
        if (action === 'save') {
            this.expenseClaimForm.value.isSubmitted = false;
            if (this.expenseClaimForm.value.expenseStatus === 'SCHEDULED') {
                this.expenseClaimForm.value.expenseStatus = 'SCHEDULED';
            }
            else {
                this.expenseClaimForm.value.expenseStatus = 'NEW';
            }
        }
        else if (action === 'submit') {
            this.expenseClaimForm.value.isSubmitted = true;
            this.expenseClaimForm.value.expenseStatus = 'SUBMITTED';
        }
        this.spinner.show();
        this.expenseClaimForm.value.isSubmitted = true;
        var expenseFormData = __assign({}, this.expenseClaimForm.value);
        this.bpgExpensesService.saveExpense(expenseFormData).subscribe(function (data) {
            _this.finalExpenseData = data;
            _this.spinner.hide();
            _this.expenseClaimForm.patchValue(data);
            if (_this.selectedFiles.length > 0) {
                _this.uploadFlag = 'create-expense';
                var _loop_1 = function (file) {
                    var uploadData = {
                        'category': 'uploadDocument',
                    };
                    _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.awsUrls = data;
                                    return [4 /*yield*/, this.uploadService.getPresignedUrl(file, this.awsUrls, this.finalExpenseData.expenseId, this.uploadFlag)];
                                case 1:
                                    _a.sent();
                                    if (localStorage.getItem('uploadError') !== 'Error') {
                                        this.alertSuccess = true;
                                    }
                                    setTimeout(function () {
                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                    }, 200);
                                    this.spinner.hide();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, function (err) {
                        _this.spinner.hide();
                        if (err.value.statusText === ConstantValues.unknownError) {
                            _this.timeOutError = true;
                        }
                        setTimeout(function () {
                            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        }, 200);
                    });
                };
                for (var _i = 0, _a = _this.selectedFiles; _i < _a.length; _i++) {
                    var file = _a[_i];
                    _loop_1(file);
                }
            }
            else {
                if (action === 'save') {
                    _this.alertSuccessOnSave = true;
                }
                else if (action === 'submit') {
                    _this.alertSuccess = true;
                }
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
        });
    };
    /** to select cancel
    * @class CreateAndEditExpenseClaimComponent
    * @method cancelClick
    */
    CreateAndEditExpenseClaimComponent.prototype.cancelClick = function () {
        this.method = "navigate";
        this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
        this.param = "";
    };
    /** to select confirm
     * @class CreateAndEditExpenseClaimComponent
     * @method submitClick
     */
    CreateAndEditExpenseClaimComponent.prototype.saveClick = function () {
        this.method = "saveExpense";
        this.msg1 = " Do you want to save this expense ?";
        this.param = "save";
    };
    /** to select confirm
      * @class CreateAndEditExpenseClaimComponent
      * @method submitClick
      */
    CreateAndEditExpenseClaimComponent.prototype.submitClick = function () {
        this.method = "saveExpense";
        this.msg1 = " Do you want to submit this expense ?";
        this.param = "submit";
    };
    CreateAndEditExpenseClaimComponent.prototype.navigate = function () {
        sessionStorage.setItem(this.buttonType, "CANCEL");
        this.location.back();
        window.scrollTo(0, 0);
    };
    CreateAndEditExpenseClaimComponent.prototype.trimValue = function (formControl) {
        if (formControl.value != null && formControl.value !== '') {
            formControl.setValue(formControl.value.trim());
        }
    };
    /** To disable form inputs based on hoshin selection
  * @class CreateAndEditExpenseClaimComponent
  * @method disableInputBasedOnSelection
  */
    CreateAndEditExpenseClaimComponent.prototype.disableInputBasedOnSelection = function (isExpense) {
        if (isExpense === true) {
            this.expenseClaimForm.controls['eventId'].setValue(null);
            this.expenseClaimForm.controls['eventId'].enable();
        }
        else if (isExpense === false) {
            this.expenseClaimForm.controls['eventId'].setValue(null);
            this.expenseClaimForm.controls['eventId'].disable();
        }
    };
    CreateAndEditExpenseClaimComponent.prototype.getHoshinItemsBasedOnChapterSelection = function (chapterId, eventId, hoshinId) {
        var _this = this;
        this.actionTitleHoshin = "";
        this.expenseClaimForm.controls['hoshinId'].setValue(null);
        this.filter.chapterId = chapterId;
        this.filter.eventId = eventId;
        this.filter.hoshinId = hoshinId;
        this.landingDTOModel.filter = this.filter;
        this.bpgEventService.getHoshinListForDropDown(this.landingDTOModel).subscribe(function (data) {
            _this.HoshinDropDown = data;
            if (_this.HoshinDropDown != null) {
                for (var _i = 0, _a = _this.HoshinDropDown; _i < _a.length; _i++) {
                    var hoshin = _a[_i];
                    if (_this.HoshinDropDown.length === 1 && hoshin['isMapped'] === true) {
                        _this.actionTitleHoshin = "DISABLE";
                        _this.expenseClaimForm.patchValue({
                            hoshinId: hoshin['hoshinId']
                        });
                    }
                }
            }
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    return CreateAndEditExpenseClaimComponent;
}());
export { CreateAndEditExpenseClaimComponent };
